import { fetchAuthSession } from 'aws-amplify/auth'; 
import { getJson, postJson } from "./httpClient";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const encuestaService = {
    save: async (encuesta:Encuesta[])=>{
        try{
            const sesion = await fetchAuthSession();
            const token=sesion.tokens?.idToken;
            const data = await postJson<SaveEncuestaResponse>(`${API_BASE_URL}/survey/save`, encuesta, {
                "Authorization": `Bearer ${token}`,
            });
            
            //console.log("response:"+JSON.stringify(data));
            return data;
        }catch(error){
            console.error("Error al crear encuesta:", error);
            throw error;
        }
    },
    get:async ()=>{
        try {
            const sesion = await fetchAuthSession();
            const token = sesion.tokens?.idToken;
            const data = await getJson<GetEncuestaResponse>(`${API_BASE_URL}/survey/get`, {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            });
            //console.log("consulta encuesta:"+JSON.stringify(data));
            return data.survey?? null;
        } catch (error) { 
            console.error("Error al obtener encuesta:", error);
            throw error;
        }
    }
}

export interface Encuesta {
    id?: number;
    score: number;
    comment: string;
    questionId: number | null;
    question: string | null;
    type: string|null;
}

export interface SaveEncuestaResponse {
    survey: Encuesta[];
    message: string;
}
export interface GetEncuestaResponse {
    survey: Encuesta[]
    message: string;
}
